import { render, staticRenderFns } from "./michel-rolland.vue?vue&type=template&id=6028f224&scoped=true"
import script from "./michel-rolland.vue?vue&type=script&lang=js"
export * from "./michel-rolland.vue?vue&type=script&lang=js"
import style0 from "./michel-rolland.vue?vue&type=style&index=0&id=6028f224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028f224",
  null
  
)

export default component.exports